import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Key, ProductConfigName } from '@oy/types/src/Config/FrontendConfig';
import { useActionButtonShortcutImpl } from 'src/components/RouterActionButton/useActionButtonShortcutImpl';
import { useTranslate } from 'src/hooks';
import { useFrontendConfigs } from 'src/hooks/useFrontendConfig';
import { useFaq } from 'src/pages/HelpAndDocumentation/hooks/useFaq';

export const useBulkDisbursementCreationButton = () => {
  const { getTranslation } = useTranslate();
  const { handleFaqCategoryClick } = useFaq();
  const { getConfigAsBoolean } = useFrontendConfigs();
  const showVendorMaintenance = getConfigAsBoolean(
    ProductConfigName.BULK_DISBURSE,
    Key.SHOW_VENDOR_MAINTENANCE,
  );

  const { state: stateShortcut, action: actionShortcut } =
    useActionButtonShortcutImpl();

  const { showSideModal, isShortcut } = stateShortcut;
  const { setShowShortcutSideModal, setShowSideModal } = actionShortcut;

  const closeFaqModal = () => {
    if (isShortcut) {
      setShowShortcutSideModal(true);
    }
  };

  const handleFaqModal = () => {
    actionShortcut.setIsShortcut(true);
    setShowShortcutSideModal(false);
    handleFaqCategoryClick({
      id_prefix: 'SM',
      subCategoryPrefix: ['D'],
      subCategoryIndex: 0,
      onParentClose: () => closeFaqModal(),
      customHeader: 'FAQ',
      customTitle: getTranslation('common_bulk_disbursement'),
      useCategoryTitleAsHeader: true,
    });
  };

  const handleToggleSideModal = () => {
    AnalyticsManager.instance().track(
      AnalyticsEvent.click_bank_maintenance_button,
      {
        click_from: 'bulk_disburse_list',
      },
    );
    setShowSideModal(!showSideModal);

    if (isShortcut) {
      setShowShortcutSideModal(false);
    }
  };

  const state = {
    showVendorMaintenance,
    ...stateShortcut,
  };

  const action = {
    handleToggleSideModal,
    handleFaqModal,
    ...actionShortcut,
  };
  return { state, action };
};
